var Codec = require('io/codec');
var parser = require('./topic-selector-parser');

var topicSelectorSerialiser = {
    read : function(input) {
        return parser(Codec.readString(input));
    },
    write : function(out, selector) {
        Codec.writeString(out, selector.expression);
    }
};

module.exports = topicSelectorSerialiser;


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/topics/topic-selector-serialiser.js
// module id = 158
// module chunks = 0